"use client";

import { PageReplaySchema } from "@/sanity/pages/PageReplayTemplate";
import AffiliateWebhookProvider from "@/components/global/AffiliateWebhookProvider";
import ScrollingBanner from "@/components/pageComponents/global/ScrollingBanner";
import { ReplayHero } from "@/components/pageComponents/replay/ReplayHero";
import { ReplayOffers } from "@/components/pageComponents/replay/ReplayOffers";

export default function PageReplayJSX({ data }: { data: PageReplaySchema }) {
  return (
    <AffiliateWebhookProvider enabled={data.forwardAffiliateToWebhook === true}>
      <div className="relative w-full bg-[#fbfbfb]">
        <ReplayHero data={data} />
        {/* Serif marquee strip (Figma 8610:813); the 0.5rem gap shows the hero's rounded corners on desktop */}
        <ScrollingBanner
          variant="serif"
          className="lg:mt-[0.5rem]"
          wordClassName="text-[2.25rem] leading-[1.146] tracking-[-0.045rem] lg:text-[2.5rem] lg:tracking-[-0.05rem]"
          words={data.scrollingWords?.words}
          wordsI18n={data.scrollingWords?.wordsI18n}
        />
        <ReplayOffers data={data} />
      </div>
    </AffiliateWebhookProvider>
  );
}
